export default __webpack_public_path__ + "static/media/taxactindia3.355c704d.png";